import { render, staticRenderFns } from "./orderByWorkshop.vue?vue&type=template&id=2dc13982&scoped=true"
import script from "./orderByWorkshop.vue?vue&type=script&lang=js"
export * from "./orderByWorkshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc13982",
  null
  
)

export default component.exports